__turbopack_context__.v({
  "appstore-on-android": "app-button-module-scss-module__Ods4VG__appstore-on-android",
  "button": "app-button-module-scss-module__Ods4VG__button",
  "googleplay-on-ios": "app-button-module-scss-module__Ods4VG__googleplay-on-ios",
  "responsive-image": "app-button-module-scss-module__Ods4VG__responsive-image",
});
